import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  border-bottom: 1px solid #fff;
  height: 70px;
  position: relative;
  color: #40403F;
  &.fixed {
    position: fixed;
    top: 76px;
    left: 0;
    right: 0;
    z-index: 4;
    overflow: hidden;
  }
  .button-filter-mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70px;
    background: none;
    border: 0;
    font-family: Helvetica;
    font-size: 14px;
    color: #40403F;
    letter-spacing: 0.31px;
    span {
      align-items: center;
      display: flex;
      i {
        height: 20px;
        width: 20px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        display: inline-block;
        &.icon {
          background-image: url(/images/streamline-icon-filter-1@140x140@2x.png);
          margin-right: 10px;
        }
        &.arrow {
          background-image: url(/images/arrow-down.png);
          margin-left: 10px;
        }
      }
    }
    &.open {
      background: #E59134;
      color: #fff;
      .icon {
        background-image: url(/images/streamline-icon-filter-1@140x140@2x-branco.png);
      }
      .arrow {
        background-image: url(/images/arrow-right.png);
        transform: rotate(-90deg);
      }
    }
  }
  .mobile-options {
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    margin: 0;
    padding: 0;
    z-index: 10;
    li {
      display: block;
      background: #DEDEDE;
      height: 70px;
      border-top: 1px solid #fff;
      a {
        border-right: 0;
      }
    }
  }
  .title,
  a {
    height: 100%;
    display: flex;
    width: 20%;
    box-sizing: border-box;
    font-size: 16px;
    align-items: center;
    text-decoration :none;
    border-bottom: 4px solid transparent;
    color: #40403F;
    border-right: 1px solid #fff;
    &.active {
      border-bottom: 4px solid #F1A857;
    }
    @media (max-width: 789px) {
      width: 100%;
    }
  }
  .title {
    width: 10%;
    @media (max-width: 900px) {
      display: none;
    }
  }
  a {
    font-weight: 600;
    justify-content: center;
    transition: all 0.3s;
    &:hover {
      background: #fff;
    }
    i {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-size: contain;
      margin-right: 14px;
      &.blog {
        background-image: url(/images/streamline-icon-social-profile-click@140x140@2x.png);
      }
      &.videos {
        background-image: url(/images/streamline-icon-video-player-subtitle@140x140@2x.png);
      }
      &.aprenda-mais {
        background-image: url(/images/aprendamais.png);
      }
    }
    @media (min-width: 540px) and (max-width: 900px) {
      width: 25%;
    }
  }
  .grow {
    @media (max-width: 540px) {
      display: none;
    }
    justify-content: flex-end;
    flex-grow: 1;
    a {
      background: none;
      border: 0;
      width: 100%;
      color: #40403F;
      text-decoration: none;
      font: 16px Montserrat;
      float: right;
      display: flex;
      align-items: right;
      justify-content: flex-end;
      i {
        width: 20px;
        height: 20px;
        display: inline-block;
        background: url(/images/streamline-icon-keyboard-arrow-return@40x40@2x.png) no-repeat center;
        background-size: contain;
        margin-right: 14px;
      }
    }
  }
`

class Bar extends Component {
  state = {
    fixed: false,
    isMobile: false,
    optionMobile: false,
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.resize.bind(this));
    this.resize()
  }

  resize = () => {
    if (document.body.clientWidth > 789) {
      this.setState({ isMobile: false });
    } else {
      this.setState({ isMobile: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.resize);
  }

  handleScroll = (event) => {
    if ((document.body.clientWidth > 789 && window.scrollY > 182)) {
      this.setState({fixed: true});
      document.querySelector("body").classList.add('bar-fixed')
    } else {
      this.setState({fixed: false});
      document.querySelector("body").classList.remove('bar-fixed')
    }
  };

  render () {
    const { filter } = this.props;
    const { language } = this.context;
    let title = ''
    let title2 = ''
    let reset = ''
    let verTodos = ''
    let aprendaMais = ''
    let videos = ''
    switch (language) {
      case 'pt-br':
        title = 'Filtrar resultados';
        title2 = 'Filtrar por';
        reset = 'Resetar Filtros';
        verTodos = 'Ver todos';
        aprendaMais = 'Aprenda mais';
        videos = 'Vídeos';
        break;
      case 'en-us':
        title = 'Filter results';
        title2 = 'Filter by';
        reset = 'Remove Filters';
        verTodos = 'View all';
        aprendaMais = 'Learn more';
        videos = 'Videos';
        break;
      case 'es-es':
        title = 'Filtrar Resultados';
        title2 = 'Filtrado por';
        reset = 'Quitar filtros';
        verTodos = 'Ver todo';
        aprendaMais = 'Aprende más';
        videos = 'Videos';
        break;
      default:
    }
    return (
      <Container id="bar-blog" className={ this.state.fixed ? 'fixed' : '' }>
        {
          this.state.isMobile ? (
            <>
              <button onClick={ (e) => { this.setState({'optionMobile': !this.state.optionMobile}) }} className={ `button-filter-mobile ${this.state.optionMobile ? 'open' : ''}` }>
                <span>
                  <i className="icon"></i>
                  <span>{ title }</span>
                  <i className="arrow"></i>
                </span>
              </button>
              {
                this.state.optionMobile && (
                  <ul className="mobile-options">
                    <li>
                      <Link onClick={ (e) => { this.setState({'optionMobile': false}) }} to={ `/conteudos/blog` } className={ filter === 'blog' ? 'active' : '' }>
                        <i className="blog"></i>
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ (e) => { this.setState({'optionMobile': false}) }} to={ `/conteudos/videos` } className={ filter === 'videos' ? 'active' : '' }>
                        <i className="videos"></i>
                        { videos }
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ (e) => { this.setState({'optionMobile': false}) }} to={ `/conteudos/aprenda-mais` } className={ filter === 'aprenda-mais' ? 'active' : '' }>
                        <i className="aprenda-mais"></i>
                        { aprendaMais }
                      </Link>
                    </li>
                  </ul>
                )
              }
            </>
          ) : (
            <div className="wrapper flex">
              <span className="title">{ title2 }:</span>
              <Link to={ `/conteudos/blog` } className={ filter === 'blog' ? 'active' : '' }>
                <i className="blog"></i>
                Blog
              </Link>
              <Link to={ `/conteudos/videos` } className={ filter === 'videos' ? 'active' : '' }>
                <i className="videos"></i>
                { videos }
              </Link>
              <Link to={ `/conteudos/aprenda-mais` } className={ filter === 'aprenda-mais' ? 'active' : '' }>
                <i className="aprenda-mais"></i>
                { aprendaMais }
              </Link>
              {
                filter && (
                  <div className="grow">
                    <Link to="/conteudos">
                      <i></i>
                      { reset }
                    </Link>
                  </div>
                )
              }
            </div>
          )
        }
      </Container>
    )
  }
}

Bar.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Bar.contextType = LanguageContext;

export default Bar;
